import { ExpansionPanelDetails } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

interface AccordionDetailsProps {
  disableRootStyles?: boolean;
}

const AccordionDetails = withStyles(theme => ({
  root: (props: AccordionDetailsProps) =>
    (props.disableRootStyles ?? false)
      ? {}
      : {
          borderRadius: 5,
          padding: theme.spacing(1.25, 1.25, 1.25, 3.5),
          '&:hover': {
            background: 'color-mix(in srgb, var(--ds-color-neutral-900, #0f172a) 12.16%, transparent)',
          },
          '&:active': {
            background: 'color-mix(in srgb, var(--ds-color-neutral-900, #0f172a) 32.16%, transparent)',
          },
          '& > *:first-child': {
            fontSize: 14,
            width: '70%',
          },
          '& > *:nth-child(2)': {
            width: '30%',
            textAlign: 'right',
          },
        },
}))(ExpansionPanelDetails);

AccordionDetails.defaultProps = {
  disableRootStyles: false,
};
export default AccordionDetails;
